module.exports = __webpack_public_path__ + "img/find-my-friend.7439155c.svg";